import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowLeftRight from './icon-arrow-left-right.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowLeftRight {...validProps} />;
}
SvgComponent.iconName = 'arrowLeftRight';

export const ArrowLeftRightIcon = svgIconWrapper(SvgComponent);
